import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  // 用户的基本信息
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
}

const options = {
  state,
  mutations,
  actions,
  modules: {
  }
}

export default new Vuex.Store(options)



// WEBPACK FOOTER //
// ./src/store/index.js